import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRoadBlock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 38,
	height: 38,
	viewBox: "0 0 38 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_live_map_road_block)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 34,
					height: 34,
					rx: 17,
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 1,
					y: 1,
					width: 32,
					height: 32,
					rx: 16,
					stroke: "white",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M21.1081 8H22.8378V17H21.1081V8ZM9 8H10.7297V24H9V8ZM15.0541 8H16.7838V12H15.0541V8ZM15.0541 14H16.7838V18H15.0541V14ZM15.0541 20H16.7838V24H15.0541V20ZM25 20.41L23.7805 19L21.973 21.09L20.1654 19L18.9459 20.41L20.7535 22.5L18.9459 24.59L20.1654 26L21.973 23.91L23.7805 26L25 24.59L23.1924 22.5L25 20.41Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_live_map_road_block",
			x: 0,
			y: 0,
			width: 37.4,
			height: 37.4,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", {
					dx: 2,
					dy: 2
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .7 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_live_map_road_block"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_live_map_road_block",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgRoadBlock);
export { ForwardRef as ReactComponent };
